import { render, staticRenderFns } from "./EditSubject.vue?vue&type=template&id=7f723066"
import script from "./EditSubject.vue?vue&type=script&lang=js"
export * from "./EditSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports